/**
 * IncorporadorSidebar - Sidebar do painel de incorporadores
 *
 * Menu de navegação para acesso do incorporador:
 * - Dashboard: Visão geral das diligências
 * - Nova Solicitação: Criar nova diligência
 * - Minhas Diligências: Lista de diligências
 * - Minhas Incorporações: Incorporações aprovadas
 */

import React from 'react';
import {
  LayoutDashboard,
  FilePlus,
  ClipboardList,
  Building2,
  HelpCircle,
  Bell,
} from 'lucide-react';
import { BaseSidebar, NavigationItem } from './BaseSidebar';

interface IncorporadorSidebarProps {
  onSidebarToggle?: (open: boolean) => void;
}

export const IncorporadorSidebar: React.FC<IncorporadorSidebarProps> = ({ onSidebarToggle }) => {
  const navigationItems: NavigationItem[] = [
    {
      label: 'Dashboard',
      href: '/incorporador/dashboard',
      icon: <LayoutDashboard className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Nova solicitação',
      href: '/incorporador/nova-solicitacao',
      icon: <FilePlus className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Minhas diligências',
      href: '/incorporador/diligencias',
      icon: <ClipboardList className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Minhas incorporações',
      href: '/incorporador/incorporacoes',
      icon: <Building2 className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Notificacoes',
      href: '/incorporador/configuracoes/notificacoes',
      icon: <Bell className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: 'Suporte',
      href: '/incorporador/suporte',
      icon: <HelpCircle className="text-sidebar-foreground size-4 shrink-0" />,
    },
  ];

  return (
    <BaseSidebar
      navigationItems={navigationItems}
      profilePath="/incorporador/profile"
      onSidebarToggle={onSidebarToggle}
      bodyGap={6}
    />
  );
};

export default IncorporadorSidebar;
